import NumberOfForms from '../../../../components/editable-cell/form-items/number-of-forms'
import { onAnyStandardCell } from '../../helpers/helpers'
import type { CalculationColumn } from '../../types/column-types'

export const numberOfFormsColumn: CalculationColumn = {
    dataIndex: 'numberOfForms',
    title: (
        <>
            Кол-во <br />
            форм
        </>
    ),
    width: 50,
    editable: true,
    FormItem: <NumberOfForms />,
    onCell: onAnyStandardCell,
}
